module.exports = __webpack_public_path__ + "img/Asso_WM_04.f35c6c3d.jpg";